/**
 * @desc 新品下单-修改并提交工作流
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(
  body: defs.basics.ProductOrderRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/productOrder/updateAndCommit`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
